module.exports = __webpack_public_path__ + "img/l4.604fbea3.png";